import { apiCall } from "api/axios";
import { IExportResponseData } from "api/business-user-management/types";
import { formatObjectToQueryString, getTodayAsEndDateFilterValue } from "utils";

import {
  IExportIndividualTransactionsPayload,
  IGetIndividualBillPaymentsTransactionsPayload,
  IGetIndividualBillPaymentsTransactionsResult,
  IGetIndividualODPStatsPayload,
  IGetIndividualODPTransactionsPayload,
  IGetIndividualODPTransactionsResult,
  IGetIndividualTODPransactionsStatsResult,
  IGetIndividualTransactionsAnalyticsPayload,
  IGetIndividualTransactionsAnalyticsResult,
  IGetIndividualTransactionsStatsPayload,
  IGetIndividualTransactionsStatsResult,
  IGetIndividualTransfersTransactionsPayload,
  IGetIndividualTransfersTransactionsResult,
  IGetODPTransactionDetailsPayload,
  IGetODPTransactionDetailsResult,
} from "./types";

export const getIndividualTransactionsStats = async (
  payload: IGetIndividualTransactionsStatsPayload
) => {
  const queryString = formatObjectToQueryString(
    payload as unknown as Record<string, string>
  );
  const result = await apiCall({
    apiRoute: `/control/transactions/individual/stat?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IGetIndividualTransactionsStatsResult;
};

export const getIndividualODPTransactionsStats = async (
  payload: IGetIndividualODPStatsPayload
) => {
  const queryString = formatObjectToQueryString(
    payload as unknown as Record<string, string>
  );
  const result = await apiCall({
    apiRoute: `/control/transactions/individual/odp/stat?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IGetIndividualTODPransactionsStatsResult;
};

export const getIndividualTransactionsAnalytics = async (
  payload: IGetIndividualTransactionsAnalyticsPayload
) => {
  const queryString = formatObjectToQueryString(
    payload as unknown as Record<string, string>
  );
  const result = await apiCall({
    apiRoute: `/control/transactions/individual/analysis?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IGetIndividualTransactionsAnalyticsResult;
};

export const exportIndividualTransactionsData = async (
  payload: IExportIndividualTransactionsPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/transactions/individual/export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const getIndividualTransfersTransactions = async (
  payload: IGetIndividualTransfersTransactionsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/transactions/individual/transfer?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  //   console.log({ result });
  return result as IGetIndividualTransfersTransactionsResult;
};

export const getIndividualBillPaymentsTransactions = async (
  payload: IGetIndividualBillPaymentsTransactionsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/transactions/individual/bill-payment?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  //   console.log({ result });
  return result as IGetIndividualBillPaymentsTransactionsResult;
};

export const getIndividualODPTransactions = async (
  payload: IGetIndividualODPTransactionsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/transactions/individual/odp?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGetIndividualODPTransactionsResult;
};

export const getODPTransactionDetails = async (
  payload: IGetODPTransactionDetailsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/transactions/odp-transaction-detail",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGetODPTransactionDetailsResult;
};
